export enum ImportanceType {
    FREQUENTLY_USED = 'Frequently Used',
    NORMALLY_USED = 'Normally Used',
    RARELY_USED = 'Rarely Used',
    UNUSED = 'Unused',
    UNKNOWN = 'Unknown'
}
